module.exports = __webpack_public_path__ + "static/media/danielEquipe.55cf2fdc.jpg";